export const orgTypeChoices = [
  { id: 'vet', name: 'Vet' },
  { id: 'employer', name: 'Employer' },
  { id: 'partner', name: 'Partner' },
  { id: 'large_group', name: 'Large Group' },
];
export const vetAssociationStates = ['NY', 'MN', 'HI'];
